/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_DescriptionInputs */

const en_privacy_description = /** @type {(inputs: Privacy_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PureJSON privacy policy. Learn how we protect your data with 100% client-side processing.`)
};

const ko_privacy_description = /** @type {(inputs: Privacy_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PureJSON 개인정보처리방침. 100% 클라이언트 사이드 처리로 데이터를 보호하는 방법을 알아보세요.`)
};

const ja_privacy_description = /** @type {(inputs: Privacy_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PureJSONのプライバシーポリシー。100%クライアントサイド処理でデータを保護する方法をご覧ください。`)
};

/**
* | output |
* | --- |
* | "PureJSON privacy policy. Learn how we protect your data with 100% client-side processing." |
*
* @param {Privacy_DescriptionInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const privacy_description = /** @type {((inputs?: Privacy_DescriptionInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_DescriptionInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_privacy_description(inputs)
	if (locale === "ko") return ko_privacy_description(inputs)
	return ja_privacy_description(inputs)
});